import React from "react";
import { useAppSelector, useAppDispatch } from "../../../../common/hooks/hooks";
import { setActiveTab, UserTab } from "../../userSlice";
import { useGetUserProfileQuery } from "../../api/userAuthApi";
import { useUserLogout } from "../../hooks/useUserLogout";
import ProfileSidebar from "./ProfileSidebar";
import ProfileContent from "./ProfileContent/ProfileContent";

const ProfileDashboard: React.FC = () => {
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector(
    (state) => state.user?.activeTab || "dashboard"
  );

  const { data: profile, isLoading: isProfileLoading } =
    useGetUserProfileQuery();
  const { handleLogout, isLoading: isLoggingOut } = useUserLogout();

  const handleTabChange = (tab: UserTab) => {
    dispatch(setActiveTab(tab));
  };

  return (
    <div className="profile-dashboard">
      <div className="profile-dashboard__container">
        <ProfileSidebar
          activeTab={activeTab}
          onTabChange={handleTabChange}
          onLogout={handleLogout}
        />
        <main className="profile-content">
          {/* Show loader while logging out to lock UI interaction */}
          {isLoggingOut ? (
            <div
              className="profile-content__loading"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
              }}
            >
              <div className="loader-spinner"></div>
            </div>
          ) : (
            <ProfileContent
              activeTab={activeTab}
              profile={profile}
              isLoading={isProfileLoading}
              onTabChange={handleTabChange}
            />
          )}
        </main>
      </div>
    </div>
  );
};

export default ProfileDashboard;
